var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { class: _vm.linkClasses }, [
      !_vm.withLinkBottom
        ? _c("button", {
            class: [
              _vm.buttonClasses,
              "ob1-link-arrow down",
              _vm.isMini ? "ob1-link-small" : null,
              _vm.isLarge ? "ob1-link-large" : null,
              _vm.maxWidth100 ? "mw-100" : null,
            ],
            attrs: {
              id: _vm.buttonId,
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": "#" + _vm.collapsedBlockId,
              "aria-controls": _vm.collapsedBlockId,
              "aria-expanded": "false",
            },
            domProps: { innerHTML: _vm._s(_vm.buttonLabel) },
            on: { click: _vm.clickHandler },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: _vm.collapsedBlockId,
          role: "region",
          "aria-labelledby": _vm.buttonId,
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("div", { class: _vm.linkClasses }, [
      _vm.withLinkBottom
        ? _c("button", {
            class: [
              "ob1-link-arrow",
              _vm.isMini ? "ob1-link-small" : null,
              _vm.isLarge ? "ob1-link-large" : null,
              _vm.maxWidth100 ? "mw-100" : null,
              _vm.buttonClasses,
            ],
            attrs: {
              id: _vm.buttonId,
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": "#" + _vm.collapsedBlockId,
              "aria-controls": _vm.collapsedBlockId,
              "aria-expanded": "false",
            },
            domProps: { innerHTML: _vm._s(_vm.buttonLabel) },
            on: { click: _vm.clickHandler },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }